import React from "react";
import "./style.scss";

const MovieInformation = ({ movie }) => {
    if (!movie) return null;

    return (
        <div className="movie-details__wrapper">
            <div className="movie-details__details">
                {movie.review && (
                    <>
                        <p className="movie-details__details-list-title">Synopsis</p>
                        <p className="movie-details__details-item" key={movie.review.id}>
                            {movie.review.review_description}
                        </p>
                    </>
                )}

                {movie.directors?.length > 0 && (
                    <ul className="movie-details__details-list">
                        <li className="movie-details__details-list-title">Director:</li>
                        {movie.directors.map((director) => (
                            <li className="movie-details__details-list-item" key={director.id}>
                                {director.director_name}
                            </li>
                        ))}
                    </ul>
                )}

                {movie.cast?.length > 0 && (
                    <ul className="movie-details__details-list">
                        <li className="movie-details__details-list-title">Starring:</li>
                        {movie.cast.map((actor, i) => (
                            <li className="movie-details__details-list-item" key={i}>
                                {actor.actor_name}
                            </li>
                        ))}
                    </ul>
                )}

                {movie.genres?.length > 0 && (
                    <ul className="movie-details__details-list">
                        <li className="movie-details__details-list-title">Genre:</li>
                        {movie.genres.map((genre, i) => (
                            <li className="movie-details__details-list-item" key={i}>
                                {genre.genre_name}
                            </li>
                        ))}
                    </ul>
                )}

                {movie.rating && (
                    <p className="movie-details__details-item">Rating: {movie.rating}</p>
                )}
                {movie.release_year && (
                    <p className="movie-details__details-item">Release Date: {movie.release_year}</p>
                )}
                {movie.running_time && (
                    <p className="movie-details__details-item">Running Time: {movie.running_time}</p>
                )}
            </div>
        </div>
    );
};

export default MovieInformation;
